module.exports = new __parcel__URL__("npm.a467f58f.svg").toString();